import React from "react";

const DataCard = ({ title, action, children, padded = false }) => (
  <div className="billr-card">
    {(title || action) && (
      <div className="billr-card-header">
        {title && <h5>{title}</h5>}
        {action}
      </div>
    )}
    <div className={`billr-card-body${padded ? " padded" : ""}`}>{children}</div>
  </div>
);

export default DataCard;
